// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__pWyHH","colCheckbox":"styles_colCheckbox__xsmK7"};